import React, { Component } from "react";

import { Modal } from "../../.common/Modal/Modal";
import { LayoutContext } from "../../../modules/ContextModules/LayoutContext";

import './AttributesModal.css'

export class AttributesModal extends Component {
    static contextType = LayoutContext;
    render() {
        return (
            <Modal content={this.props.content} style={{left: this.props.position.x, top: this.props.position.y}} onOutterClick={this.handleOutterClick}/>
        );
    }

    handleOutterClick = (e) => {
        const {attributesModalContext} = this.context;
        attributesModalContext.updateContent({isOpened: false})
    }
}
    